import styled from 'styled-components';
import { DarkTheme, LightTheme, ThemeType } from 'src/packages/theme';
import { NavIconWithPopoverStyles } from '../NavLink.types';

export const getNavIconWithPopoverStyles = (theme: ThemeType): NavIconWithPopoverStyles => {
  return {
    popoverMenuBgColor:
      theme === 'light'
        ? LightTheme.colors.background.secondary.BG3
        : DarkTheme.colors.background.secondary.BG3,
    menuItemBgColorHover:
      theme === 'light'
        ? LightTheme.colors.background.secondary.BG4
        : DarkTheme.colors.background.secondary.BG4,
    menuItemLabelColor:
      theme === 'light' ? LightTheme.colors.text.primary : DarkTheme.colors.text.primary,
    iconColor: theme === 'light' ? LightTheme.colors.text.primary : DarkTheme.colors.text.primary,
  };
};

export const NavIconWithPopoverContainer = styled.div<{ nopointer: boolean }>`
  width: 100%;
  position: relative;
  z-index: 9999;

  &:hover {
    .nav-icon {
      cursor: ${(props) => (props.nopointer ? 'initial' : 'pointer !important')};

      svg {
        path[stroke] {
          stroke: ${(props) => props.theme.colors.palette.primary};
        }

        path[fill] {
          fill: ${(props) => props.theme.colors.palette.primary};
        }
      }
    }
  }

  li {
    list-style: none;
  }
`;

export const MenuWrapper = styled.div`
  position: absolute;
  top: 24px;
  right: -100%;
  padding-top: 15px;
`;

export const LinksMenu = styled.div<{
  popoverMenuBgColor: string;
  menuItemBgColorHover: string;
}>`
  display: flex;
  flex-direction: column;
  width: max-content;
  box-shadow: 0 1px 2px rgb(36 43 50 / 20%), 0 0 2px rgb(36 43 50 / 12%),
    0 0 2px rgb(36 43 50 / 14%);
  border-radius: 4px;
  overflow: hidden;

  ul {
    list-style: none;
    background-color: ${(props) => props.popoverMenuBgColor};
    width: 100%;
    margin: 0;
    padding: 10px;

    a {
      padding: 14px 10px;
      margin: 0;
      min-width: 160px;
      width: 100%;
      cursor: pointer;
      border-radius: 6px;

      &:hover {
        cursor: pointer;
        background-color: ${(props) => props.menuItemBgColorHover};

        * {
          cursor: pointer;
        }
      }
    }
  }
`;
